import React, { useEffect } from 'react';
import { Dialog } from '@rio-cloud/rio-uikit';
import { FormattedMessage } from 'react-intl';
import CampaignTargetVehiclesForm from '~/features/campaigns/components/campaignForm/CampaignTargetVehiclesForm';
import { useForm } from 'react-hook-form';
import { useCreateStageMutation, useEditStageMutation } from '~/api/stages/Stages.api';

interface CreateStageDialogProps {
    isOpen: boolean;
    onHide: () => void;
    campaignId?: number;
    initialGroup?: string | null;
    stageId?: number | null;
    onSave: () => void;
}

const CreateStageDialog: React.FC<CreateStageDialogProps> = ({
    isOpen,
    onHide,
    onSave,
    campaignId,
    initialGroup,
    stageId,
}) => {
    const { control, setValue, handleSubmit } = useForm();
    const [createStage,] = useCreateStageMutation();
    const [editStage,] = useEditStageMutation();

    useEffect(() => {
        setValue('targetGroups', initialGroup);
    }, [initialGroup, setValue]);
    const handleSave = handleSubmit(async(data) => {
        try {
            const stageData = {
                vehicleGroup: data.targetGroups,
                campaignId: campaignId,
            };
            if (stageId) {
                await editStage({
                    ...stageData,
                    id: stageId
                }).unwrap().then(() => {
                    onSave();
                });
            } else {
                await createStage(stageData).unwrap().then(() => {
                    onSave();
                });
            }
            onHide();
        } catch (error) {
            console.error('Failed to create stage:', error);
        }
    });

    const handleCancel = () => {
        onHide();
    };
    return (
        <Dialog
            show={isOpen}
            onClose={onHide}
            title={<FormattedMessage id={stageId ? 'Edit Stage' : 'Create New Stage'}/>}
            body={<CampaignTargetVehiclesForm
                control={control}
                setValue={setValue}
            />}
            footer={
                <div className='display-flex justify-content-end'>
                    <div className='display-flex justify-content-end gap-10'>
                        <button
                            className='btn btn-default'
                            onClick={handleCancel}
                        >
                            <FormattedMessage id='intl-msg:cancel'/>
                        </button>
                        <button
                            className='btn btn-primary'
                            onClick={handleSave}
                        >
                            <FormattedMessage id='intl-msg:save'/>
                        </button>
                    </div>
                </div>
            }
        >

        </Dialog>
    );
};

export default CreateStageDialog;
